import { DarkFaEdit } from '../../../order/overview/Summary/DarkFaEdit';
import React from 'react';
import { FlexRow, BoldHeader5Text, NavigationItem, SmallBodyText } from 'ui-toolkit';
import { ISummaryItemProps } from './SummaryItem';
import { StyledSummaryItem } from './SummaryItem.styles';
import { useShouldSummaryItemRender } from '../useShouldSummaryItemRender';

export interface ISummaryItemWithLinkProps extends ISummaryItemProps {
  href?: string;
  to?: string;
  onClick?: () => void;
  children?: React.ReactNode;
}

export const SummaryItemWithLink: React.FC<ISummaryItemWithLinkProps> = ({
  children,
  label,
  href,
  to,
  onClick,
  tab,
}) => {
  const shouldRender = useShouldSummaryItemRender(label, tab);
  if (!shouldRender) {
    return null;
  }
  return (
    <StyledSummaryItem>
      <FlexRow justifyContent={'space-between'}>
        <BoldHeader5Text>{label}</BoldHeader5Text>
        <NavigationItem href={href} to={to} onClick={onClick} text={`Edit ${label}`}>
          <DarkFaEdit />
        </NavigationItem>
      </FlexRow>
      <SmallBodyText>{children}</SmallBodyText>
    </StyledSummaryItem>
  );
};
